import { useFormSubmit } from "@/hooks/useFormSubmit";

const benefits = [
  { id: 1, icon: "ri-heart-3-line", text: "Sertai komuniti sukarelawan yang penyayang" },
  { id: 2, icon: "ri-medal-line", text: "Sijil penghargaan & jam khidmat komuniti" },
  { id: 3, icon: "ri-group-line", text: "Rangkaian rakan & pengalaman berharga" },
];

const VOLUNTEER_FORM_URL = "https://readdy.ai/api/form/da57hp30muk3qhp2tsc0";

export default function Volunteer() {
  const { status, errorMsg, handleSubmit } = useFormSubmit(VOLUNTEER_FORM_URL);

  return (
    <section id="sukarelawan" className="w-full bg-primary-900 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left info */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block text-accent-400 text-sm font-semibold uppercase tracking-wider mb-3">
              Sukarelawan
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-background-50 leading-tight">
              Jadilah Sebahagian Daripada Perubahan
            </h2>
            <p className="mt-5 text-sm md:text-base text-background-50/75 leading-relaxed">
              Masa dan tenaga anda amat berharga. Sertai kami sebagai sukarelawan
              dan bantu kami menyampaikan bantuan kepada lebih ramai insan yang
              memerlukan di seluruh Malaysia.
            </p>
            <div className="mt-8 space-y-4">
              {benefits.map((b) => (
                <div key={b.id} className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 text-accent-400">
                    <i className={`${b.icon} text-lg`}></i>
                  </span>
                  <p className="text-sm text-background-50/85">{b.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right form */}
          <div className="w-full lg:w-1/2">
            <form
              id="form-sukarelawan"
              data-readdy-form
              onSubmit={handleSubmit}
              className="bg-background-50 rounded-lg p-6 md:p-8"
            >
              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 mb-6">
                Daftar Sukarelawan
              </h3>

              <div className="space-y-4">
                <div>
                  <label htmlFor="vol-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    Nama Penuh
                  </label>
                  <input
                    id="vol-name"
                    name="name"
                    type="text"
                    required
                    placeholder="Nama anda"
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="vol-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      Emel
                    </label>
                    <input
                      id="vol-email"
                      name="email"
                      type="email"
                      required
                      placeholder="emel@contoh.com"
                      className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                  </div>
                  <div>
                    <label htmlFor="vol-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      No. Telefon
                    </label>
                    <input
                      id="vol-phone"
                      name="phone"
                      type="tel"
                      placeholder="012-345 6789"
                      className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="vol-program" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    Program yang Diminati
                  </label>
                  <select
                    id="vol-program"
                    name="program"
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
                  >
                    <option value="">Pilih program</option>
                    <option value="bencana">Bantuan Kecemasan & Bencana</option>
                    <option value="pendidikan">Pendidikan Anak Yatim & Asnaf</option>
                    <option value="makanan">Bantuan Makanan</option>
                    <option value="kesihatan">Program Kesihatan Komuniti</option>
                    <option value="ramadan">Bantuan Ramadan & Raya</option>
                    <option value="umum">Khidmat Sukarelawan Umum</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="vol-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    Mesej (Pilihan)
                  </label>
                  <textarea
                    id="vol-message"
                    name="message"
                    rows={3}
                    maxLength={500}
                    placeholder="Ceritakan bagaimana anda ingin membantu..."
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
                  ></textarea>
                </div>

                {/* Anti-spam helper field */}
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="field-aux"
                />

                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {status === "loading" ? "Menghantar..." : "Hantar Pendaftaran"}
                </button>

                {status === "success" && (
                  <p className="text-sm text-primary-600 font-medium text-center">
                    Terima kasih! Pendaftaran anda telah diterima. Kami akan menghubungi anda tidak lama lagi.
                  </p>
                )}
                {status === "error" && (
                  <p className="text-sm text-secondary-600 font-medium text-center">
                    {errorMsg}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}